export const convertDate = (dateString) => {
  const [year, month, day] = dateString.split("-");
  return `${month}-${day}-${year}`;
};
